import { AlertTriangle, CheckCircle2, CircleDashed } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import type { TradeIdeasHealthCheck } from "@/lib/tradeideas/types";

export function HealthCheckList({ checks }: { checks: TradeIdeasHealthCheck[] }) {
  return (
    <section className="overflow-hidden rounded-md border border-border">
      <div className="grid grid-cols-[1fr_120px_2fr] border-b border-border bg-muted/30 px-3 py-2 text-[11px] font-medium uppercase tracking-wider text-muted-fg">
        <span>Check</span>
        <span>Status</span>
        <span>Message</span>
      </div>
      {checks.length === 0 ? (
        <div className="px-3 py-6 text-center text-sm text-muted-fg">
          No health checks reported.
        </div>
      ) : (
        checks.map((check) => <HealthCheckRow key={check.name} check={check} />)
      )}
    </section>
  );
}

function HealthCheckRow({ check }: { check: TradeIdeasHealthCheck }) {
  return (
    <div className="grid grid-cols-[1fr_120px_2fr] items-center gap-3 border-b border-border/60 px-3 py-2 text-sm last:border-b-0">
      <div className="flex min-w-0 items-center gap-2">
        <HealthIcon status={check.status} />
        <span className="truncate font-mono text-xs">{check.name}</span>
      </div>
      <Badge variant={badgeVariant(check.status)}>{check.status}</Badge>
      <div className="min-w-0">
        <div className="truncate text-xs text-muted-fg">{check.message}</div>
      </div>
    </div>
  );
}

function HealthIcon({ status }: { status: string }) {
  if (status === "ok") return <CheckCircle2 className="size-4 text-emerald-300" />;
  if (status === "critical") return <AlertTriangle className="size-4 text-red-300" />;
  return <CircleDashed className="size-4 text-amber-300" />;
}

function badgeVariant(status: string) {
  if (status === "ok") return "success";
  if (status === "critical") return "danger";
  return "warn";
}
